import { useEffect, useRef } from 'react';

/**
 * Reports that the patient left the step holding it. Only the active step is
 * rendered, so an intro step uses this to report that they started rather than
 * that the page loaded.
 */
export const TrackOnLeave = ({ onLeave }: { onLeave: () => void }) => {
  const onLeaveRef = useRef(onLeave);
  onLeaveRef.current = onLeave;

  useEffect(() => () => onLeaveRef.current(), []);

  return null;
};
